import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap/dist/css/bootstrap-theme.css';
// import '../node_modules/font-awesome/css/font-awesome.min.css';
import Ancestry from './App';
import registerServiceWorker from './registerServiceWorker';

let postPath;
if (typeof window.ancestryPostPath !== 'undefined') {
    postPath = window.ancestryPostPath;
}
let targetContainer;
let dataTarget;
if (typeof window.ancestryTargetContainer !== 'undefined') {
    targetContainer = window.ancestryTargetContainer;
} else {
    targetContainer = 'userforms_ancestry';
}

if (typeof document.ancestryDataTarget !== 'undefined') {
    dataTarget = document.ancestryDataTarget;
} else {
    dataTarget = null;
}



ReactDOM.render(<Ancestry post={postPath} dataTarget={dataTarget} />, document.getElementById(targetContainer));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js